module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gl-cart-block"
  }, [(_vm.totalCount > 0) ? _c('div', [_c('a', {
    attrs: {
      "href": "/shop/cart"
    }
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.numeral(_vm.totalCount).format('0,0')) + " на сумму " + _vm._s(_vm.numeral(_vm.totalPrice).format('0.00 $')) + "\n    ")])]) : _c('div', [_vm._v("\n    Корзина пуста\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-link"
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v("\n            \n       ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-034c0fff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/cart-info/Widget.vue
// module id = 602
// module chunks = 2